// Custom Modal Button HTML Element
class CustomModalButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener("click", (event) => {
            const modal_name = event.target.dataset.modalName;
            window.MicroModal.show(modal_name);
        });
    }
  }

customElements.define("custom-modal-button", CustomModalButton);


// Custom Link Button HTML Element
class CustomLinkButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener("click", (event) => {
            const url = event.target.dataset.url;
            const target = event.target.dataset.target;
            window.open(url, target);
        });
    }
  }

customElements.define("custom-link-button", CustomLinkButton);

// mobile menu
class MobileMenuCtrl extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener("click", (event) => {
            document.querySelector("body").classList.add("it-mobile--menu-open");
        });
    }
  }

customElements.define("mobile-menu-ctrl", MobileMenuCtrl);

// mobile menu close
class MobileMenuClose extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener("click", (event) => {
            document.querySelector("body").classList.remove("it-mobile--menu-open");
        });
    }
  }

customElements.define("mobile-menu-close", MobileMenuClose);


// Global Add to Cart Function

function add_to_cart(items, url="/cart") {
    const itemsObj = {
    'items': items
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(itemsObj)
    })
    .then(function() {
        window.location.href=url;
    })
    .catch(function(error) {
        console.error('Error:', error);
    });
}